<template>
    <div
        class="is-full-width height-error is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
        <div>
            <FileNew v-if="!isError" />
            <FileError v-else />
        </div>
        <div class="tittle">
            <span v-if="!isError">Sube el documento de Excel</span>
            <span v-else>Error detectado en tu archivo</span>
        </div>
        <p class="sub_tittle has-text-centered">
            <span v-if="!isError">
                No podemos mostrar la lista sin el documento.
                Descarga el template, complétalo y súbelo.
            </span>
            <span v-else>
                {{ msgError }}
            </span>
        </p>
    </div>
</template>

<script>
import FileError from "@/components/svg/FileError.vue";
import FileNew from "@/components/svg/FileNew.vue";
export default {
    name: "MsgToUploadFile",
    components: {
        FileNew,
        FileError
    },
    data() {
        return {
        }
    },
    props: {
        isError: { type: Boolean, default: false },
        msgError: { type: String, default: "" },
        isFileUpload: { type: Boolean, default: false },
    }
}
</script>

<style scoped lang="scss">
.height-error {
    height: 400px;
}

.tittle {
    color: var(--Gray-900, #101828);
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
}

.sub_tittle {
    color: var(--Gray-600, #475467);

    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}
</style>